/* eslint-disable import/first */
import React from 'react';
import { Grid } from '@material-ui/core';
import { useNavigate } from '@reach/router';
import css from './index.module.scss';
import { CloseIcon } from '../Icons';
export default function PopUpHeading({ heading, onClose }) {
  return (
    <React.Fragment>
      <Grid className={css.root}>
        <div className={css.heading}>{heading}</div>
        <div className={css.closeButton} onClick={onClose}>
          <CloseIcon />
        </div>
      </Grid>
    </React.Fragment>
  );
}
